/* =====================================================================
   PRODUCT PAGE ENGINE · COMPORTAMIENTO
   Sin dependencias. Cada pieza es un custom element independiente.
   Los precios llegan ya calculados y formateados desde Liquid
   (snippet ppe-offer-data): el JS solo elige, no calcula.
   ===================================================================== */
(function () {
  'use strict';
  document.documentElement.classList.add('ppe-js');
  var PPE = (window.PPE = window.PPE || {});
  PPE.state = { offer: null, tier: null, variant: null };

  /* ---------- estado único de compra (hero, barra fija) ---------- */
  function currentPrices() {
    var o = PPE.state.offer, t = PPE.state.tier;
    if (!o || !t) return null;
    return t.prices[String(PPE.state.variant)] || t.prices[Object.keys(t.prices)[0]];
  }
  PPE.render = function () {
    var p = currentPrices(); if (!p) return;
    document.querySelectorAll('[data-ppe-bind="total"]').forEach(function (e) { e.textContent = p.total; });
    document.querySelectorAll('[data-ppe-bind="compare"]').forEach(function (e) { e.textContent = p.compare || ''; e.hidden = !p.compare; });
    document.querySelectorAll('[data-ppe-tier]').forEach(function (i) { i.checked = i.value === PPE.state.tier.handle; });
    // variante: precio unitario, disponibilidad y formulario de respaldo
    var o = PPE.state.offer, v = o.variants && o.variants[String(PPE.state.variant)];
    if (v) {
      document.querySelectorAll('[data-ppe-bind="unit"]').forEach(function (e) { e.textContent = v.price; });
      document.querySelectorAll('[data-ppe-bind="unit-compare"]').forEach(function (e) { e.textContent = v.compare || ''; e.hidden = !v.compare; });
      document.querySelectorAll('[data-ppe-bind="unit-save"]').forEach(function (e) { e.textContent = (e.dataset.tpl || '').replace('[pct]', v.pct || ''); e.hidden = !v.pct; });
      document.querySelectorAll('[data-ppe-add]').forEach(function (b) {
        b.disabled = !v.available;
        var l = b.querySelector('[data-ppe-atc-label]') || (b.children.length ? null : b);
        if (l && o.labels) l.textContent = v.available ? o.labels.atc : o.labels.soldout;
      });
    }
    document.querySelectorAll('[data-ppe-input="id"]').forEach(function (e) { e.value = PPE.state.variant; });
    document.querySelectorAll('[data-ppe-input="quantity"]').forEach(function (e) { e.value = PPE.state.tier.quantity; });
    document.querySelectorAll('[data-ppe-input="offer"]').forEach(function (e) { e.value = PPE.state.tier.handle; });
    // precios de cada tarjeta para la variante actual
    PPE.state.offer.tiers.forEach(function (t) {
      var tp = t.prices[String(PPE.state.variant)]; if (!tp) return;
      document.querySelectorAll('[data-ppe-tier-total="' + t.handle + '"]').forEach(function (e) { e.textContent = tp.total; });
      document.querySelectorAll('[data-ppe-tier-compare="' + t.handle + '"]').forEach(function (e) { e.textContent = tp.compare || ''; e.hidden = !tp.compare; });
      document.querySelectorAll('[data-ppe-tier-save="' + t.handle + '"]').forEach(function (e) { e.textContent = (e.dataset.tpl || '').replace('[pct]', tp.pct || ''); e.hidden = !tp.pct; });
    });
    PPE.syncPicks();
    document.dispatchEvent(new CustomEvent('ppe:change', { detail: { tier: PPE.state.tier, variant: PPE.state.variant } }));
  };
  PPE.setTier = function (handle) {
    var t = PPE.state.offer && PPE.state.offer.tiers.find(function (x) { return x.handle === handle; });
    if (t) { PPE.state.tier = t; PPE.render(); }
  };
  PPE.setVariant = function (id) {
    PPE.state.variant = String(id); PPE.render();
    PPE.showMedia(document.querySelector('[data-ppe-variant][value="' + id + '"], [data-ppe-pick-input] option[value="' + id + '"]'));
    try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
  };

  // la galería salta a la foto de la variante elegida (si la tiene)
  // las fotos de variante viven fuera de la galería: entra solo la del peluche elegido, al final
  PPE.showMedia = function (inp) {
    if (inp && inp.tagName === 'SELECT') inp = inp.options[inp.selectedIndex];
    var mid = inp && inp.getAttribute('data-media-id'), g = document.querySelector('ppe-gallery');
    if (!mid || !g || !g.go) return;
    var sel = '[data-media-id="' + mid + '"]', store = document.querySelector('[data-ppe-var-store]');
    if (store && !g.track.querySelector(sel)) {
      g.querySelectorAll('[data-ppe-var]').forEach(function (el) { store.appendChild(el); });
      var slide = store.querySelector('.ppe-gallery__slide' + sel), th = store.querySelector('.ppe-thumb' + sel);
      if (slide) g.track.appendChild(slide);
      if (th && g.list) g.list.appendChild(th);
      g.thumbs = Array.prototype.slice.call(g.querySelectorAll('.ppe-thumb'));
    }
    var sl = g.track.children; for (var k = 0; k < sl.length; k++) { if (sl[k].getAttribute('data-media-id') === mid) { g.go(k); break; } }
  };
  /* ---------- una variante por unidad del pack (p. ej. 2 peluches distintos) ---------- */
  PPE.syncPicks = function () {
    var box = document.querySelector('[data-ppe-picks]'); if (!box) return;
    var n = (PPE.state.tier && PPE.state.tier.quantity) || 1;
    // va dentro de la burbuja del pack elegido
    var inp = PPE.state.tier && document.querySelector('[data-ppe-tier][value="' + PPE.state.tier.handle + '"]');
    var card = inp && inp.closest('.ppe-tier') && inp.closest('.ppe-tier').querySelector('.ppe-tier__card');
    if (card && box.parentNode !== card) card.appendChild(box);
    box.querySelectorAll('[data-ppe-pick]').forEach(function (row) {
      var k = Number(row.getAttribute('data-ppe-pick'));
      row.hidden = k > n;
      var num = row.querySelector('[data-ppe-pick-num]'); if (num) num.textContent = box.getAttribute('data-unit') + (n > 1 ? ' ' + k : '');
      var sel = row.querySelector('[data-ppe-pick-input]'), opt = sel && sel.options[sel.selectedIndex], img = row.querySelector('[data-ppe-pick-img]');
      if (opt && img && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
    });
  };
  // ids elegidos para las n unidades del pack (null si la página no tiene selector por unidad)
  PPE.picks = function (n) {
    var box = document.querySelector('[data-ppe-picks]'); if (!box) return null;
    var ids = [];
    for (var k = 1; k <= n; k++) { var s = box.querySelector('[data-ppe-pick="' + k + '"] [data-ppe-pick-input]'); ids.push(s && s.value ? s.value : String(PPE.state.variant)); }
    return ids;
  };

  /* ---------- carrito: el precio lo aplica Shopify (descuento automático) ---------- */
  PPE.addToCart = function () {
    var o = PPE.state.offer, t = PPE.state.tier; if (!o || !t) return;
    var v = o.variants && o.variants[String(PPE.state.variant)];
    if (v && !v.available) return;
    if (PPE._busy) return;   // evita dobles clics que duplicarían cantidades
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var mode = document.documentElement.dataset.ppeCart || 'redirect';
    // carrito lateral premium (ppe-cart-drawer) si está activo; si no, el cajón del tema o la página /cart
    var ppeCart = (window.PPECart && window.PPECart.enabled) ? window.PPECart : null;
    var drawer = (!ppeCart && mode === 'event') ? document.querySelector('cart-drawer') : null;
    // tachados de los packs (los mismos de la ficha) para el carrito lateral: "cantidad:céntimos,…" en una propiedad oculta
    var cents = function (m) { var d = String(m || '').replace(/[^\d]/g, ''); return d ? Number(d) : 0; };
    var refs = (o.tiers || []).map(function (x) { var p = x.prices && x.prices[String(PPE.state.variant)]; return (p && cents(p.compare) > cents(p.total)) ? x.quantity + ':' + cents(p.compare) : ''; }).filter(Boolean).join(',');
    // una línea por variante elegida (2 o 3 distintas si el cliente las mezcla)
    var ids = PPE.picks(t.quantity) || [String(PPE.state.variant)], order = [], count = {};
    if (ids.length !== t.quantity) ids = [String(PPE.state.variant)];
    ids.forEach(function (id) { if (!count[id]) { count[id] = 0; order.push(id); } count[id] += ids.length === 1 ? t.quantity : 1; });
    var tp = t.prices && t.prices[String(PPE.state.variant)], packRef = (tp && cents(tp.compare) > cents(tp.total)) ? cents(tp.compare) : 0, given = 0;
    var body = { items: order.map(function (id, i) {
      var props = { _ppe_offer: t.handle }; if (refs) props._ppe_cmp = refs;
      // pack mezclado: el tachado del pack se reparte entre las líneas para que la suma sea exacta
      if (order.length > 1 && packRef) { var share = i === order.length - 1 ? packRef - given : Math.round(packRef * count[id] / t.quantity); given += share; props._ppe_ref = count[id] + ':' + share; }
      return { id: Number(id), quantity: count[id], properties: props };
    }) };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
    if (ppeCart) { body.sections = ppeCart.sectionIds(); body.sections_url = location.pathname; }
    if (window.PPE_PREVIEW) { PPE.toast('Vista previa: se añadirían ' + t.quantity + ' ud. · oferta "' + t.handle + '". El precio final lo calcula Shopify.'); return; }
    PPE._busy = true;
    var buttons = document.querySelectorAll('[data-ppe-add]');
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var done = function () { PPE._busy = false; buttons.forEach(function (b) { b.removeAttribute('aria-busy'); }); };
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('ppe:cart:added', { detail: data }));
        if (ppeCart) { ppeCart.render(data.sections); ppeCart.open(); done(); return; }
        // cajón de carrito del tema (Dawn) si existe y se ha elegido; si no, página de carrito
        if (drawer && data.sections && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(data); done(); return; }
        window.location.href = root + 'cart';
      })
      .catch(function (err) { done(); PPE.toast((err && (err.description || err.message)) || o.error_text || 'No se ha podido añadir al carrito. Inténtalo de nuevo.'); });
  };
  PPE.toast = function (msg) {
    var el = document.getElementById('ppe-toast');
    if (!el) { el = document.createElement('div'); el.id = 'ppe-toast'; el.setAttribute('role', 'status'); el.className = 'ppe'; el.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);background:#161616;color:#fff;padding:12px 16px;border-radius:12px;font:500 14px/1.4 var(--ppe-font-body,sans-serif);z-index:60;max-width:calc(100vw - 32px);transition:opacity .3s'; document.body.appendChild(el); }
    el.textContent = msg; el.style.opacity = '1'; clearTimeout(el._t); el._t = setTimeout(function () { el.style.opacity = '0'; }, 4000);
  };

  /* ---------- formulario de producto ---------- */
  class PPEProductForm extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('script[data-ppe-offer]');
      if (data && !PPE.state.offer) {
        PPE.state.offer = JSON.parse(data.textContent);
        PPE.state.variant = String(PPE.state.offer.variant);
        PPE.state.tier = PPE.state.offer.tiers.find(function (t) { return t.handle === PPE.state.offer.default; }) || PPE.state.offer.tiers[0];
        PPE.render();
      }
      this.addEventListener('change', function (e) {
        if (e.target.matches('[data-ppe-tier]')) PPE.setTier(e.target.value);
        if (e.target.matches('[data-ppe-variant]')) PPE.setVariant(e.target.value);
        if (e.target.matches('[data-ppe-pick-input]')) {
          var row = e.target.closest('[data-ppe-pick]');
          if (row && row.getAttribute('data-ppe-pick') === '1') PPE.setVariant(e.target.value); else { PPE.syncPicks(); PPE.showMedia(e.target); }
        }
      });
      this.addEventListener('click', function (e) { if (e.target.closest('[data-ppe-add]')) { e.preventDefault(); PPE.addToCart(); } });
    }
  }

  /* ---------- galería ---------- */
  class PPEGallery extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('.ppe-gallery__track');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.ppe-thumb'));
      this.list = this.querySelector('.ppe-thumbs__list');
      this.i = 0;
      this.addEventListener('click', function (e) {
        var th = e.target.closest('.ppe-thumb'); if (th) return self.go(self.thumbs.indexOf(th));
        if (e.target.closest('[data-dir="prev"]')) self.go(self.i - 1);
        if (e.target.closest('[data-dir="next"]')) self.go(self.i + 1);
      });
      this.track.addEventListener('scroll', function () {
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        if (i !== self.i) { self.i = i; self.sync(); }
      }, { passive: true });
    }
    go(i) { var n = this.track.children.length; this.i = (i + n) % n; this.track.scrollTo({ left: this.track.clientWidth * this.i, behavior: 'smooth' }); this.sync(); }
    sync() {
      var self = this;
      this.thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === self.i); });
      var t = this.thumbs[this.i];
      if (t && this.list) this.list.scrollTo({ left: t.offsetLeft - this.list.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }
  }

  /* ---------- carrusel genérico (en escritorio puede ser rejilla) ---------- */
  class PPECarousel extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('.ppe-carousel__track');
      this.counter = this.querySelector('[data-counter]');
      this.dots = this.querySelector('.ppe-dots');
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dir]'); if (!b || !self.track.children[0]) return;
        var w = self.track.children[0].getBoundingClientRect().width + 14;
        self.track.scrollBy({ left: b.dataset.dir === 'next' ? w : -w, behavior: 'smooth' });
      });
      this.track.addEventListener('scroll', function () { self.update(); }, { passive: true });
      addEventListener('resize', function () { self.build(); });
      this.build();
    }
    perView() { var c = this.track.children[0]; return c ? Math.max(1, Math.round(this.track.clientWidth / (c.getBoundingClientRect().width + 12))) : 1; }
    build() { if (this.dots) this.dots.innerHTML = Array.from({ length: Math.ceil(this.track.children.length / this.perView()) }, function () { return '<i></i>'; }).join(''); this.update(); }
    update() {
      var c = this.track.children[0]; if (!c) return;
      var i = Math.round(this.track.scrollLeft / (c.getBoundingClientRect().width + 14));
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.track.children.length;
      if (this.dots) { var pv = this.perView(); Array.prototype.forEach.call(this.dots.children, function (d, j) { d.classList.toggle('is-on', j === Math.floor(i / pv)); }); }
    }
  }

  /* ---------- vídeo: toca para reproducir; autoplay en silencio solo en pantalla ---------- */
  class PPEVideo extends HTMLElement {
    connectedCallback() {
      var self = this; this.v = this.querySelector('video'); if (!this.v) return;
      this.v.muted = true; this.v.playsInline = true;
      this.addEventListener('click', function () {
        if (self.v.paused) { self.v.play(); self.classList.add('is-playing'); } else { self.v.pause(); self.classList.remove('is-playing'); }
      });
      if (this.hasAttribute('autoplay') && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) {
          if (e.isIntersecting) { self.v.play().catch(function () {}); self.classList.add('is-playing'); } else { self.v.pause(); self.classList.remove('is-playing'); }
        }); }, { threshold: .4 }).observe(this);
      }
    }
  }

  /* ---------- barra fija: aparece al pasar el botón principal ---------- */
  class PPESticky extends HTMLElement {
    connectedCallback() {
      var self = this;
      var update = function () {
        var main = document.querySelector('[data-ppe-main-atc]');
        var passed = main ? main.getBoundingClientRect().bottom < 0 : true;
        var footer = document.querySelector('footer, .footer, [id*="footer"]');
        var atFooter = footer ? footer.getBoundingClientRect().top < innerHeight - 40 : false;
        self.classList.toggle('is-visible', passed && !atFooter);
      };
      addEventListener('scroll', update, { passive: true });
      addEventListener('resize', update);
      update();
      this.addEventListener('click', function (e) { if (e.target.closest('[data-ppe-add]')) PPE.addToCart(); });
    }
  }

  /* ---------- rotador de mensajes ---------- */
  class PPERotator extends HTMLElement {
    connectedCallback() {
      var items = Array.prototype.slice.call(this.children); if (items.length < 2) return;
      var i = 0; items.forEach(function (x, j) { x.hidden = j !== 0; });
      setInterval(function () { items[i].hidden = true; i = (i + 1) % items.length; items[i].hidden = false; }, 3500);
    }
  }

  /* ---------- aparición al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.ppe-reveal:not(.is-in)');
    if (document.documentElement.dataset.ppeMotion !== 'on' || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  document.addEventListener('DOMContentLoaded', initReveal);
  document.addEventListener('shopify:section:load', initReveal);   // Theme Editor
  setTimeout(initReveal, 0);

  function def(n, c) { if (!customElements.get(n)) customElements.define(n, c); }
  def('ppe-product-form', PPEProductForm);
  def('ppe-gallery', PPEGallery);
  def('ppe-carousel', PPECarousel);
  def('ppe-video', PPEVideo);
  def('ppe-sticky-atc', PPESticky);
  def('ppe-rotator', PPERotator);
})();
